import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase } from '@fortawesome/free-solid-svg-icons';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../assets/styles/Timeline.scss'

function Timeline() {
  return (
    <div id="history">
      <div className="items-container">
        <h1>Career History</h1>
        <VerticalTimeline>
          <VerticalTimelineElement
            className="vertical-timeline-element--work"
            contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
            contentArrowStyle={{ borderRight: '7px solid  white' }}
            date="June 2026 - Present"
            iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
            icon={<FontAwesomeIcon icon={faBriefcase} />}
          >
            <h3 className="vertical-timeline-element-title">Flutter Developer Intern</h3>
            <h4 className="vertical-timeline-element-subtitle">Wid Wins, Chennai</h4>
            <p>
              Developing a Fintech app using Flutter, integrating Firebase (Authentication, Firestore, Storage, Cloud functions, App config)
            </p>
          </VerticalTimelineElement>
          <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: 'white', color: 'rgb(39, 40, 34)' }}
          contentArrowStyle={{ borderRight: '7px solid  white' }}
          date="May 2025 - August 2025"
          iconStyle={{ background: '#5000ca', color: 'rgb(39, 40, 34)' }}
          icon={<FontAwesomeIcon icon={faBriefcase} />}
        >
          <h3 className="vertical-timeline-element-title">Flutter Developer Intern</h3>
          <h4 className="vertical-timeline-element-subtitle">ICT Academy of Kerala, Technopark Trivandrum</h4>
          <p>
            Flutter app development
          </p>
        </VerticalTimelineElement>
        </VerticalTimeline>
      </div>
    </div>
  );
}

export default Timeline;